import axios from "axios";
import processId from "../../models/workflow/processId";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getProcessId(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const id = data;
    return axios
      .get(`${url}/workflow/procesos/${id}`, { headers })
      .then(({ data }) => {
        return processId.fromJson(data);
      });
  }

  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      procesoId: data.process,
      nombre: data.name,
      nivelId: data.levels,
      obligatorio: data.mandatory,
      suficiente: data.enough,
      // enviaCorreo:data.email
    };
    return axios.post(`${url}/workflow/procesos/pasos`, payload, { headers });
  }
  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const procesoId = data.process;
    const pasoId = data.step;
    return axios.delete(
      `${url}/workflow/procesos/pasos/${procesoId}&${pasoId}`,
      {
        headers,
      }
    );
  };

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const procesoId = data.process;
    const pasoId = data.id;

    let payload = {
      nombre: data.name,
      nivelId: data.levels,
      obligatorio: data.mandatory,
      suficiente: data.enoght,
    };

    return axios
      .patch(`${url}/workflow/procesos/pasos/${procesoId}&${pasoId}`, payload, {
        headers,
      })
      .then(() => {});
  }
}
export default service;
